export const generateTrigam = (value) => {
  if (value.length > 0) {
    value = value.trim();
    value = value.toLowerCase();
    value = value.replaceAll("  ", " "); //Retirar espaço duplo;

    let trigam = [];
    if (value) {
      let words = value.split(" ");
      trigam = [...words];

      // Adiciona prefixos de cada palavra individualmente
      words.forEach(word => {
        if (word.length >= 3) {
          for (let i = 3; i <= word.length; i++) {
            const prefix = word.substring(0, i);
            if (!trigam.includes(prefix)) {
              trigam.push(prefix);
            }
          }
        }
      });

      // Adiciona prefixos da frase completa (sem espaços)
      const valueNoSpaces = value.replace(/\s+/g, '');
      if (valueNoSpaces.length >= 3) {
        for (let i = 3; i <= valueNoSpaces.length; i++) {
          const prefix = valueNoSpaces.substring(0, i);
          if (!trigam.includes(prefix)) {
            trigam.push(prefix);
          }
        }
      }

      // Adiciona a lógica original para compatibilidade
      for (let i = 0; i < value.length - 2; i++) {
        const suffix = value.substring(i, value.length);
        if (!trigam.includes(suffix)) {
          trigam.push(suffix);
        }
      }
      for (let i = 1; i < value.length - 2; i++) {
        const prefix = value.substring(0, value.length - i);
        if (!trigam.includes(prefix)) {
          trigam.push(prefix);
        }
      }
    }
    return trigam;
  } else {
    return [];
  }
};

// export const generateTrigam = (value) => {
//   if (value.length > 0) {
//     value = value.toLowerCase();
//     let trigam = [];
//     if (value) {
//       let words = value.split(" ");
//       words.forEach((word) => {
//         if (word.length > 3) {
//           for (let i = 0; i < word.length - 2; i++) {
//             trigam.push(word.substring(i, i + 3));
//           }
//         } else {
//           trigam = [...trigam, word];
//         }
//       });
//     }
//     return trigam;
//   } else {
//     return [];
//   }
// };
